import request from '@/utils/request'

/**
 * 获取角色列表
 * @param {*} data 
 */
function getRole(data){
  return request({
    url: '/role/list',
    method: 'post',
    data
  })
}
/**
 * 新增角色
 * @param {*} data 
 */
function addRole(data){
    return request({
      url: '/role',
      method: 'post',
      data
    })
  }
   /**
 * 编辑角色
 * @param {*} obj
 */
function editRole(obj) {
    return request({
      url: `/role/${obj.id}`,
      method: 'PATCH',
      data:obj.data
    })
  }
 /**
 * 设置角色权限菜单
 * @param {*} obj
 */
  function setRoleMenu(obj) {
    return request({
      url: `/role/menu/${obj.id}`,
      method: 'post',
      data:obj.data
    })
  }
  /**
 * 删除角色
 * @param {*} data
 */
function deleteRole(obj) {
    return request({
      url: `/role/${obj.id}`,
      method: 'DELETE'
    })
  }
/**
 * 获取所有的菜单
 * 
 */
function getMenuTree(type){
  const typeList = [
    '/menu/developer',
    '/menu/admin',
    '/menu/channel',
    '/menu/company',
    '/menu/subCompany',
    '/menu/department'
  ]
  return request({
    url: typeList[type],
    method: 'get'      
  })
}
/**
 * 获取对应角色菜单树
 * 
 */
function getRoleMenuTree(obj){
    return request({
      url: `/menu/role/${obj.id}`,
      method: 'get'      
    })
  }  

  function getRoleV2xList() {
    return request({
      url: '/role/list/v2x',
      method: 'get'      
    })
  }
export {
    getRole,
    addRole,
    editRole,
    setRoleMenu,
    deleteRole,
    getMenuTree,
    getRoleMenuTree,
    getRoleV2xList
  }